import React from 'react';

export default class MultiSelect extends React.PureComponent {
  constructor (props) {
    super(props);
  }

  derivedAnswer () {
    return this.props.answer || '';
  }

  derivedCorrectAnswer () {
    return this.props.correctAnswer || '';
  }

  toggleBubble (answer_opt) {
    // On the frontend, answer opts are an array, but the chosen opts
    // will still be a string.
    const answer_opts = this.props.answer_options;
    const chosen_opts = [...this.derivedAnswer()];
    let new_opts;

    if (chosen_opts.includes(answer_opt)) {
      // Filter out the option that's being toggled
      new_opts = chosen_opts.filter(opt => (opt !== answer_opt));

    } else {
      // Select only those options that we'd selected before, plus the
      // new one. Doing answer_opts.filter makes sure they're in the
      // proper order.
      new_opts = answer_opts.filter(opt => (
        opt === answer_opt || chosen_opts.includes(opt)
      ));
    }

    this.props.updateItem({answer: new_opts.join('')});
  }

  render () {
    const isSelected = letter => this.derivedAnswer().includes(letter);
    const isACorrectAnswer = letter => this.derivedCorrectAnswer().includes(letter);
    const hasCorrectAnswer = this.props.teacherView && this.props.correctAnswer != undefined;

    let selfClasses = ['choices'];
    if (hasCorrectAnswer)  selfClasses.push('has-correct-answer');
    if (this.derivedAnswer().length > 0)  selfClasses.push('answered');

    const answer_bubbles = this.props.answer_options.map((answer_opt, i) => {
      let classes = ['choice'];
      if (isSelected(answer_opt))  classes.push('active');
      if (isACorrectAnswer(answer_opt))  classes.push('correct-answer');
      if (this.props.itemDisabled)  classes.push('manually-disabled');
      return <div key={answer_opt} className={classes.join(' ')} onClick={_ => this.toggleBubble(answer_opt)}>{answer_opt}</div>
    });

    return <div className={selfClasses.join(' ')}>
             {answer_bubbles}
           </div>;
  }

}
